import "@fullcalendar/react/dist/vdom";
import { Grid, Box, Button, Typography } from "@mui/material";
import { ArrowForward as ArrowForwardIcon } from "@mui/icons-material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import JobsSchedule from "modules/jobs/JobsSchedule/JobsSchedule";
import { useSearchParams, useNavigate } from "react-router-dom";
import { DateRangeProvider } from "modules/jobs/JobsSchedule/DateRangeContext";
import JobScheduleStats from "modules/jobs/JobScheduleStats/JobScheduleStats";
import { useDateRangeContext } from "modules/jobs/JobsSchedule/DateRangeContext";

function JobScheduleStatsWithContext({ jobId }: { jobId: string | null }) {
  const { startDate, endDate } = useDateRangeContext();
  return <JobScheduleStats startDate={startDate} endDate={endDate} jobId={jobId} />;
}

function NewScheduleBanner() {
  const navigate = useNavigate();
  const [URLSearchParams] = useSearchParams();
  const jobId = URLSearchParams.get("jobId");

  const handleTryNew = () => {
    const newUrl = jobId ? `/jobs/schedule?jobId=${jobId}` : "/jobs/schedule";
    navigate(newUrl);
  };

  return (
    <Box
      sx={{
        bgcolor: "#e3f2fd",
        color: "#1565c0",
        py: 1.5,
        px: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        borderRadius: 2,
        mb: 3,
        border: "1px solid #90caf9",
      }}
    >
      <Typography variant="body2" fontWeight={500}>
        Try our new Scheduling Page
      </Typography>
      <Button
        variant="contained"
        size="small"
        endIcon={<ArrowForwardIcon sx={{ color: "white" }} />}
        onClick={handleTryNew}
        sx={{
          bgcolor: "#1976d2",
          color: "white !important",
          textTransform: "none",
          fontWeight: 600,
          "&:hover": {
            bgcolor: "#1565c0",
            color: "white !important",
          },
          ml: 1,
        }}
      >
        Try it now
      </Button>
    </Box>
  );
}

export default function JobsSchedulePageLegacy() {
  const [URLSearchParams] = useSearchParams();
  const jobId = URLSearchParams.get("jobId");

  return (
    <DashboardPage>
      <NewScheduleBanner />
      <MDBox mb={6}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MDTypography variant="h4" fontWeight="medium">
              Jobs Schedule{jobId ? ` (Job ID ${jobId})` : ""}
            </MDTypography>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MDBox display="flex" justifyContent={{ xs: "flex-start", lg: "flex-end" }}>
              <DateRangeProvider>
                <JobScheduleStatsWithContext jobId={jobId} />
              </DateRangeProvider>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Grid container spacing={3}>
        <Grid item xs={12} sx={{ fontSize: "12px" }}>
          <DateRangeProvider>
            <JobsSchedule jobId={jobId} />
          </DateRangeProvider>
        </Grid>
      </Grid>
    </DashboardPage>
  );
}
